import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=2f9648f5&scoped=true&"
import script from "./topics.vue?vue&type=script&lang=js&"
export * from "./topics.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/topic/topics.less?vue&type=style&index=0&id=2f9648f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9648f5",
  null
  
)

component.options.__file = "topics.vue"
export default component.exports